'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _getSize = require('../../../helpers/getSize');

var _getSize2 = _interopRequireDefault(_getSize);

var _sizes = require('../../../constants/sizes');

var _layout = require('../layout');

var _layout2 = _interopRequireDefault(_layout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RenewalSmallIcon = function (_React$Component) {
    _inherits(RenewalSmallIcon, _React$Component);

    function RenewalSmallIcon() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, RenewalSmallIcon);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RenewalSmallIcon.__proto__ || Object.getPrototypeOf(RenewalSmallIcon)).call.apply(_ref, [this].concat(args))), _this), _this.getIcon = function (width, height) {
            return _react2.default.createElement(
                'svg',
                { xmlns: 'http://www.w3.org/2000/svg', width: '24', height: '24.009', viewBox: '0 0 24 24.009' },
                _react2.default.createElement(
                    'g',
                    { id: 'Files-Folders_Common-Files_common-file-text-sync', 'data-name': 'Files-Folders / Common-Files / common-file-text-sync', transform: 'translate(-196 -382)' },
                    _react2.default.createElement(
                        'g',
                        { id: 'Group_62', 'data-name': 'Group 62' },
                        _react2.default.createElement(
                            'g',
                            { id: 'common-file-text-sync' },
                            _react2.default.createElement('path', { id: 'Shape_237', 'data-name': 'Shape 237', d: 'M211,400.75h-3.75v3.75', fill: 'none', stroke: '#aaa', 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'stroke-width': '1.5' }),
                            _react2.default.createElement('path', { id: 'Shape_238', 'data-name': 'Shape 238', d: 'M218.667,401.483a5.572,5.572,0,0,1-10.74-.733', fill: 'none', stroke: '#aaa', 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'stroke-width': '1.5' }),
                            _react2.default.createElement('path', { id: 'Shape_239', 'data-name': 'Shape 239', d: 'M215.5,397.75h3.75V394', fill: 'none', stroke: '#aaa', 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'stroke-width': '1.5' }),
                            _react2.default.createElement('path', { id: 'Shape_240', 'data-name': 'Shape 240', d: 'M207.833,397.017a5.572,5.572,0,0,1,10.74.733', fill: 'none', stroke: '#aaa', 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'stroke-width': '1.5' }),
                            _react2.default.createElement('path', { id: 'Shape_241', 'data-name': 'Shape 241', d: 'M199.75,388.75h10.5', fill: 'none', stroke: '#aaa', 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'stroke-width': '1.5' }),
                            _react2.default.createElement('path', { id: 'Shape_242', 'data-name': 'Shape 242', d: 'M199.75,393.25h6', fill: 'none', stroke: '#aaa', 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'stroke-width': '1.5' }),
                            _react2.default.createElement('path', { id: 'Shape_243', 'data-name': 'Shape 243', d: 'M199.75,397.75h3.75', fill: 'none', stroke: '#aaa', 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'stroke-width': '1.5' }),
                            _react2.default.createElement('path', { id: 'Shape_244', 'data-name': 'Shape 244', d: 'M203.5,402.25h-5.25a1.5,1.5,0,0,1-1.5-1.5v-16.5a1.5,1.5,0,0,1,1.5-1.5h10.629a1.5,1.5,0,0,1,1.06.439l2.872,2.872a1.5,1.5,0,0,1,.439,1.06V389.5', fill: 'none', stroke: '#aaa', 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'stroke-width': '1.5' })
                        )
                    )
                )
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(RenewalSmallIcon, [{
        key: 'render',
        value: function render() {
            var size = this.props.size || _sizes.Sizes.md;
            size = (0, _getSize2.default)(size);
            return _react2.default.createElement(
                _layout2.default,
                this.props,
                this.getIcon(size, size)
            );
        }
    }]);

    return RenewalSmallIcon;
}(_react2.default.Component);

exports.default = RenewalSmallIcon;